import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vShow as _vShow, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66fa6890"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "modalSSIRS"
}
const _hoisted_4 = { class: "contenedorSSIRS" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Escáner Evaluación ")
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"color":"white"},
  class: "fas fa-download"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "contenidoSSIRS" }
const _hoisted_10 = { class: "contenidoSSIRS" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "modalSSIRS"
}
const _hoisted_13 = { class: "contenedorSSIRS" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Escáner SIRS ")
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"color":"white"},
  class: "fas fa-download"
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "contenidoSSIRS" }
const _hoisted_19 = { class: "contenidoSSIRS" }
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 2,
  class: "modal7"
}
const _hoisted_22 = { class: "contenedor7" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, " Seleccione el Centro ", -1))
const _hoisted_24 = { class: "contenido7" }
const _hoisted_25 = { class: "contenido7" }
const _hoisted_26 = { id: "customers" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "NOMBRE"),
  /*#__PURE__*/_createElementVNode("th", null, "REGION"),
  /*#__PURE__*/_createElementVNode("th", null, "PROVINCIA")
], -1))
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "general" }
const _hoisted_30 = {
  key: 0,
  class: "modalConfirm"
}
const _hoisted_31 = { class: "contenedor" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, "Notificación", -1))
const _hoisted_33 = { class: "contenido" }
const _hoisted_34 = { class: "contenido" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Afiliado Validado Exitosamente ", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos del Afiliado")
], -1))
const _hoisted_37 = { class: "grid" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "cedula"
}, "CEDULA:", -1))
const _hoisted_39 = { class: "lds-ripple" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nombre"
}, "NOMBRE:", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "apellido"
}, "APELLIDO:", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "sexo"
}, "SEXO:", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "MASCULINO", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "FEMENINO", -1))
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "fechaNacimiento"
}, "NACIMIENTO:", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "edad"
}, "EDAD:", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nss"
}, "NSS:", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "regimen"
}, "REGIMEN:", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "SUBSIDIADO", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "CONTRIBUTIVO", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "PENSIONADO", -1))
const _hoisted_56 = [
  _hoisted_53,
  _hoisted_54,
  _hoisted_55
]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "direccion"
}, "DIRECCION:", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "telefono"
}, "TELEFONO:", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "tipo_de_contacto"
}, "TIPO DE CONTACTO:", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "PROPIO", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "PROMOTOR DE SALUD", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "GESTOR DE SALUD", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "OTROS", -1))
const _hoisted_64 = [
  _hoisted_60,
  _hoisted_61,
  _hoisted_62,
  _hoisted_63
]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "tipo_de_contacto"
}, "ESPECIFIQUE:", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nombre_contacto"
}, "NOMBRE DE CONTACTO:", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos de la Evaluación")
], -1))
const _hoisted_68 = { class: "grid" }
const _hoisted_69 = { class: "grid" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "fecha"
}, "FECHA:", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "unap"
}, "UNAP:", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "supervisor"
}, "SUPERVISOR:", -1))
const _hoisted_73 = { class: "grid" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "comentary"
}, "COMENTARIO:", -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Documentos y Soportes Escaneados")
], -1))
const _hoisted_76 = { class: "grid" }
const _hoisted_77 = { key: 0 }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_79 = { class: "form-label" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Acciones", -1))
const _hoisted_81 = [
  _hoisted_80
]
const _hoisted_82 = { class: "grid" }
const _hoisted_83 = ["disabled"]
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_85 = /*#__PURE__*/_createTextVNode(" Actualizar ")
const _hoisted_86 = [
  _hoisted_84,
  _hoisted_85
]
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-print" }, null, -1))
const _hoisted_88 = /*#__PURE__*/_createTextVNode(" Imprimir ")
const _hoisted_89 = [
  _hoisted_87,
  _hoisted_88
]
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_91 = /*#__PURE__*/_createTextVNode(" Eliminar ")
const _hoisted_92 = [
  _hoisted_90,
  _hoisted_91
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_Navbar),
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          (_ctx.cargando)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("img", {
                  class: "img",
                  src: 'https://cruzjiminian-assets-bucket.s3.amazonaws.com/webapp/images/logo.png'
                }, null, 8, _hoisted_2)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.showModalEVAL)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("header", null, [
                _hoisted_5,
                _createElementVNode("a", {
                  target: "_blank",
                  href: this.$store.state.user.evaluacion
                }, _hoisted_8, 8, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (this.showModalEVALMethod())),
                  for: "btn-modal",
                  class: "close"
                }, "Cerrar"),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("img", {
                    class: "flyer2",
                    src: this.$store.state.user.evaluacion
                  }, null, 8, _hoisted_11)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showModalSSIRS)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("header", null, [
                _hoisted_14,
                _createElementVNode("a", {
                  target: "_blank",
                  href: this.$store.state.user.consultasAfiliados
                }, _hoisted_17, 8, _hoisted_15)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("label", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (this.showModalSSIRSMethod())),
                  for: "btn-modal",
                  class: "close"
                }, "Cerrar"),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("img", {
                    class: "flyer2",
                    src: this.$store.state.user.consultasAfiliados
                  }, null, 8, _hoisted_20)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showModalAseguradoras)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      id: "search",
                      type: "search",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event)),
                      class: "form-control",
                      onKeypress: _cache[3] || (_cache[3] = ($event: any) => (_ctx.buscar()))
                    }, null, 544), [
                      [_vModelText, _ctx.search]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("table", _hoisted_26, [
                      _hoisted_27,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCentros, (centro, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: index,
                          onClick: ($event: any) => (_ctx.setCentro(centro))
                        }, [
                          _createElementVNode("td", null, _toDisplayString(centro.unap), 1),
                          _createElementVNode("td", null, _toDisplayString(centro.region), 1),
                          _createElementVNode("td", null, _toDisplayString(centro.provincia), 1)
                        ], 8, _hoisted_28))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_29, [
        (_ctx.showModalConfirm)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("label", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (this.showModalConfirmMethod())),
                    for: "btn-modal"
                  }, "X"),
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("button", {
                      class: "btn btn-success",
                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (this.showModalConfirmMethod()), ["prevent"]))
                    }, " Validar Otro Afiliado "),
                    _createElementVNode("button", {
                      class: "btn btn-info",
                      onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (this.$router.push('/evaluacions')), ["prevent"]))
                    }, " Ver Listado ")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("form", null, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("h6", null, _toDisplayString(_ctx.encabezado), 1),
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", null, [
                _hoisted_38,
                _withDirectives(_createElementVNode("div", _hoisted_39, _hoisted_42, 512), [
                  [_vShow, _ctx.showSpinner]
                ]),
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "cedula",
                  type: "cedula",
                  onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.defCedula())),
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.evaluacion.cedula) = $event)),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.evaluacion.cedula]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_43,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "nombre",
                  type: "nombre",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.evaluacion.nombre) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.nombre]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_44,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "apellido",
                  type: "apellido",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.evaluacion.apellido) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.apellido]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_45,
                _withDirectives(_createElementVNode("select", {
                  disabled: "",
                  id: "sexo",
                  type: "sexo",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.evaluacion.sexo) = $event)),
                  class: "form-select"
                }, _hoisted_48, 512), [
                  [_vModelSelect, _ctx.evaluacion.sexo]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_49,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "fechaNacimiento",
                  type: "date",
                  onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.calcularEdad(_ctx.evaluacion.fechaNacimiento))),
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.evaluacion.fechaNacimiento) = $event)),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.evaluacion.fechaNacimiento]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_50,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "edad",
                  type: "Number",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.evaluacion.edad) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.edad]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_51,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "nss",
                  type: "nss",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.evaluacion.nss) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.nss]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_52,
                _withDirectives(_createElementVNode("select", {
                  disabled: "",
                  id: "regimen",
                  type: "regimen",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.evaluacion.regimen) = $event)),
                  class: "form-select"
                }, _hoisted_56, 512), [
                  [_vModelSelect, _ctx.evaluacion.regimen]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_57,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "direccion",
                  type: "direccion",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.evaluacion.direccion) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.direccion]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_58,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "telefono",
                  type: "telefono",
                  onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.defTelefono())),
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.evaluacion.telefono) = $event)),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.evaluacion.telefono]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_59,
                _withDirectives(_createElementVNode("select", {
                  disabled: "",
                  id: "tipo_de_contacto",
                  type: "tipo_de_contacto",
                  onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.setContactName())),
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.evaluacion.tipo_de_contacto) = $event)),
                  class: "form-select"
                }, _hoisted_64, 544), [
                  [_vModelSelect, _ctx.evaluacion.tipo_de_contacto]
                ])
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _hoisted_65,
                _withDirectives(_createElementVNode("input", {
                  id: "especificacion_contacto",
                  type: "especificacion_contacto",
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.evaluacion.especificacion_contacto) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.especificacion_contacto]
                ])
              ], 512), [
                [_vShow, this.evaluacion.tipo_de_contacto == 'OTROS']
              ]),
              _createElementVNode("div", null, [
                _hoisted_66,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "nombre_contacto",
                  type: "nombre_contacto",
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.evaluacion.nombre_contacto) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.nombre_contacto]
                ])
              ])
            ]),
            _hoisted_67,
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", null, [
                  _hoisted_70,
                  _withDirectives(_createElementVNode("input", {
                    disabled: "",
                    id: "fecha",
                    type: "date",
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.evaluacion.fecha) = $event)),
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.evaluacion.fecha]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_71,
                  _withDirectives(_createElementVNode("input", {
                    disabled: "",
                    id: "unap",
                    type: "unap",
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.evaluacion.unap) = $event)),
                    class: "form-control",
                    onFocus: _cache[26] || (_cache[26] = ($event: any) => (this.showModalAseguradorasMethod()))
                  }, null, 544), [
                    [_vModelText, _ctx.evaluacion.unap]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_72,
                  _withDirectives(_createElementVNode("input", {
                    disabled: "",
                    id: "supervisor",
                    type: "supervisor",
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.evaluacion.supervisor) = $event)),
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.evaluacion.supervisor]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("div", null, [
                _hoisted_74,
                _withDirectives(_createElementVNode("textarea", {
                  id: "comentary",
                  type: "comentary",
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.evaluacion.comentary) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.comentary]
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _hoisted_75,
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("button", {
                  onClick: _cache[29] || (_cache[29] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.selectImage && _ctx.selectImage(...args)), ["prevent"])),
                  class: "btn btn-outline-primary px-4"
                }, " Cambiar Escáner SIRS "),
                _createElementVNode("button", {
                  onClick: _cache[30] || (_cache[30] = _withModifiers(($event: any) => (this.showModalSSIRSMethod()), ["prevent"])),
                  class: "btn btn-outline-primary px-4"
                }, " Ver Escáner SIRS "),
                (this.evaluacion.evaluado)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                      _createElementVNode("button", {
                        onClick: _cache[31] || (_cache[31] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.selectImageEval && _ctx.selectImageEval(...args)), ["prevent"])),
                        class: "btn btn-outline-primary px-4"
                      }, " Seleccionar Escáner Evaluación "),
                      _createElementVNode("button", {
                        onClick: _cache[32] || (_cache[32] = _withModifiers(($event: any) => (this.showModalEVALMethod()), ["prevent"])),
                        class: "btn btn-outline-primary px-4"
                      }, " Ver Escáner Evaluación ")
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_78,
              _withDirectives(_createElementVNode("label", _hoisted_79, _hoisted_81, 512), [
                [_vShow, this.evaluacion.statusAdministrativo == 'VALIDADO']
              ]),
              _createElementVNode("div", _hoisted_82, [
                _withDirectives(_createElementVNode("button", {
                  onClick: _cache[33] || (_cache[33] = _withModifiers(($event: any) => (this.deleteEvaluacion()), ["prevent"])),
                  class: "btn btn-outline-danger px-4"
                }, " Eliminar Evaluación ", 512), [
                  [_vShow, this.evaluacion.statusAdministrativo == 'VALIDADO']
                ])
              ])
            ], 512), [
              [_vShow, 
                _ctx.evaluacion.fecha &&
                  _ctx.evaluacion.cedula &&
                  _ctx.evaluacion.nombre &&
                  _ctx.evaluacion.apellido &&
                  _ctx.evaluacion.sexo &&
                  _ctx.evaluacion.fechaNacimiento &&
                  _ctx.evaluacion.edad &&
                  _ctx.evaluacion.nss &&
                  _ctx.evaluacion.regimen &&
                  _ctx.evaluacion.direccion &&
                  _ctx.evaluacion.telefono &&
                  _ctx.evaluacion.tipo_de_contacto &&
                  _ctx.evaluacion.nombre_contacto &&
                  _ctx.evaluacion.supervisor &&
                  _ctx.evaluacion.unap
              ]
            ]),
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                id: "imageInput",
                type: "file",
                ref: "fileInput",
                onInput: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args))),
                accept: "image/*"
              }, null, 544), [
                [_vShow, false]
              ]),
              _withDirectives(_createElementVNode("input", {
                id: "imageInputEval",
                type: "file",
                ref: "fileInputEval",
                onInput: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.uploadFileEval && _ctx.uploadFileEval(...args))),
                accept: "image/*"
              }, null, 544), [
                [_vShow, false]
              ])
            ]),
            (this.modoForm == 'show')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-success",
                  onClick: _cache[36] || (_cache[36] = _withModifiers(($event: any) => (_ctx.handleUpdate()), ["prevent"])),
                  disabled: 
                !_ctx.evaluacion.facNo ||
                  !_ctx.evaluacion.nombPres ||
                  !_ctx.evaluacion.codPres ||
                  !_ctx.evaluacion.aut ||
                  !_ctx.evaluacion.fechAutor ||
                  !_ctx.evaluacion.nombARS ||
                  !_ctx.evaluacion.autPor ||
                  !_ctx.evaluacion.montRec ||
                  !_ctx.evaluacion.nombPac ||
                  !_ctx.evaluacion.cedu ||
                  !_ctx.evaluacion.aflNSS ||
                  !_ctx.evaluacion.sex ||
                  !_ctx.evaluacion.edad ||
                  !_ctx.evaluacion.dir ||
                  !_ctx.evaluacion.dx
              
                }, _hoisted_86, 8, _hoisted_83))
              : _createCommentVNode("", true),
            (this.modoForm == 'show')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-warning",
                  onClick: _cache[37] || (_cache[37] = ($event: any) => (this.$router.push(`/evaluacions2/${_ctx.evaluacion._id}`)))
                }, _hoisted_89))
              : _createCommentVNode("", true),
            (_ctx.showDelete)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "btn btn-danger",
                  onClick: _cache[38] || (_cache[38] = _withModifiers(($event: any) => (_ctx.handleDelete()), ["prevent"]))
                }, _hoisted_92))
              : _createCommentVNode("", true)
          ])
        ])
      ], 512), [
        [_vShow, !_ctx.cargando]
      ])
    ])
  ]))
}